import { Button } from "@/components/ui/button";
import { SendHorizonal } from "lucide-react";
import { type KeyboardEvent, useState } from "react";

interface ChatInputProps {
  disabled?: boolean;
  onSend: (content: string) => void;
}

export function ChatInput({ disabled, onSend }: ChatInputProps) {
  const [value, setValue] = useState("");

  const submit = () => {
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setValue("");
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    // Enter to send, Shift+Enter for newline. Respect IME composition.
    if (e.key === "Enter" && !e.shiftKey && !e.nativeEvent.isComposing) {
      e.preventDefault();
      submit();
    }
  };

  return (
    <div className="flex items-end gap-2 border-t border-border/60 bg-card/70 p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] backdrop-blur-md">
      <textarea
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        rows={1}
        placeholder="메시지를 입력하세요"
        aria-label="메시지 입력"
        className="max-h-32 min-h-[44px] flex-1 resize-none rounded-xl border border-input bg-background px-3.5 py-2.5 text-sm leading-relaxed shadow-xs ring-offset-background transition-colors placeholder:text-muted-foreground focus-visible:border-primary/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/70 focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 scrollbar-thin"
        disabled={disabled}
      />
      <Button
        size="icon"
        className="h-11 w-11 shrink-0 rounded-xl"
        onClick={submit}
        disabled={disabled || !value.trim()}
        aria-label="전송"
      >
        <SendHorizonal className="h-5 w-5" />
      </Button>
    </div>
  );
}
